import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const icon = (name) => <Iconify icon={name} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  dashboard: icon('mdi:view-dashboard-outline'),
  orders: icon('mdi:receipt-text-outline'),
  menu: icon('mdi:silverware-fork-knife'),
  packages: icon('mdi:package-variant-closed'),
  inventory: icon('mdi:fridge-outline'),
  analytics: icon('mdi:chart-line'),
  forecast: icon('mdi:crystal-ball'),
  promo: icon('mdi:sale'),
  slots: icon('mdi:clock-time-four-outline'),
  corporate: icon('mdi:office-building-outline'),
  employees: icon('mdi:account-group-outline'),
  broadcast: icon('mdi:bullhorn-outline'),
  settings: icon('mdi:cog-outline'),
};

const navConfig = [
  {
    subheader: 'Операции',
    items: [
      { title: 'Обзор', path: '/dashboard/app', icon: ICONS.dashboard },
      { title: 'Заказы', path: '/dashboard/orders', icon: ICONS.orders },
      { title: 'Меню', path: '/dashboard/menu', icon: ICONS.menu },
      { title: 'Пакеты', path: '/dashboard/packages', icon: ICONS.packages },
      { title: 'Склад', path: '/dashboard/inventory', icon: ICONS.inventory },
    ],
  },
  {
    subheader: 'Аналитика',
    items: [
      { title: 'Прогноз спроса', path: '/dashboard/forecast', icon: ICONS.forecast },
      { title: 'Отчёты', path: '/dashboard/analytics', icon: ICONS.analytics },
    ],
  },
  {
    subheader: 'Продажи',
    items: [
      { title: 'Акции', path: '/dashboard/promotions', icon: ICONS.promo },
      { title: 'Слоты выдачи', path: '/dashboard/slots', icon: ICONS.slots },
      { title: 'Рассылки', path: '/dashboard/broadcasts', icon: ICONS.broadcast },
    ],
  },
  {
    subheader: 'Компании',
    items: [
      { title: 'Организации', path: '/dashboard/corporate', icon: ICONS.corporate },
      { title: 'Сотрудники', path: '/dashboard/employees', icon: ICONS.employees },
    ],
  },
  {
    subheader: 'Система',
    items: [{ title: 'Настройки', path: '/dashboard/settings', icon: ICONS.settings }],
  },
];

export default navConfig;
